import React, { useEffect, useState } from "react";
import { Phone, List, X } from "@phosphor-icons/react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Business IT", href: "#business-it" },
  { label: "Pricing", href: "#pricing" },
  { label: "Managed IT", href: "#managed-it" },
  { label: "Guides", href: "https://blog.techconnectncllc.services", external: true },
  { label: "Service Area", href: "#service-area" },
  { label: "FAQ", href: "#faq" },
];

export default function Header({ business, topOffset = 0, onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      style={{ top: `${topOffset}px` }}
      className={`fixed inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-zinc-950/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-2 text-white font-heading font-extrabold tracking-tight">
          <span className="h-8 w-8 rounded-lg bg-blue-600 grid place-items-center text-white text-sm">TC</span>
          <span className="text-lg">{business?.name || "TechCare Pro"}</span>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-300">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              target={n.external ? "_blank" : undefined}
              rel={n.external ? "noopener" : undefined}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${business?.phoneTel || "+19197375442"}`}
            data-testid="header-phone-cta"
            className="inline-flex items-center gap-2 text-zinc-300 hover:text-white text-sm"
          >
            <Phone size={18} weight="duotone" />
            <span className="tabular-nums">{business?.phone}</span>
          </a>
          <button
            onClick={() => onBook && onBook()}
            data-testid="header-book-btn"
            className="inline-flex items-center rounded-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm font-semibold transition-colors blue-glow"
          >
            Book Now
          </button>
          <a
            href="#contact"
            data-testid="header-diagnostic-btn"
            className="inline-flex items-center rounded-full bg-white text-zinc-900 px-4 py-2 text-sm font-semibold hover:bg-zinc-100 transition-colors"
          >
            Free Diagnostic
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-zinc-950/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-4 py-4 flex flex-col gap-3 text-zinc-200">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                target={n.external ? "_blank" : undefined}
                rel={n.external ? "noopener" : undefined}
                onClick={() => setOpen(false)}
                className="py-1 hover:text-white"
              >
                {n.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="rounded-full bg-blue-600 text-white px-4 py-2 text-center font-semibold">
              Free Diagnostic
            </a>
            <button onClick={() => { setOpen(false); onBook && onBook(); }} className="rounded-full bg-white text-zinc-900 px-4 py-2 font-semibold">
              Book Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
